module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    staticClass: "examine-form",
    attrs: {
      "label-width": "84px"
    }
  }, [_c('h6', {
    staticClass: "title"
  }, [_vm._v("设备情况")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Hi幼教样机数量",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formData.ProtoTypeNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ProtoTypeNum", $$v)
      },
      expression: "formData.ProtoTypeNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Hi幼教样机已抵扣数",
      "required": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formData.ProtoTypeDeductibleNum))])])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "HIC样机数量",
      "required": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formData.HiCProtoTypeNum))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "HIC样机抵扣数",
      "required": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formData.HiCProtoTypeDeductibleNum))])])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "智趣坞样机数量",
      "required": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formData.BookProtoTypeNum))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "智趣坞样机已抵扣数",
      "required": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formData.BookProtoTypeDeductibleNum))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订购数",
      "required": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formData.OrderNums))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "已绑定",
      "required": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formData.BindNums))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "已升级1.1.7数",
      "required": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formData.UpgradeDeviceNums))])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cbc9a152!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/agent-other-info1/index.vue
// module id = 1563
// module chunks = 1